import { useCallback } from 'react';

import { useAnnotationsStore } from '../context/zustand/annotationsStore';
import { AnnotationPotreeObject } from '../types';

export const useToggleAnnotationVisibility = () => {
  const annotations = useAnnotationsStore((state) => state.annotations);
  const areAllAnnotationsHidden = useAnnotationsStore(
    (state) => state.areAllAnnotationsHidden
  );
  const setAllAnnotationsHidden = useAnnotationsStore(
    (state) => state.setAllAnnotationsHidden
  );

  const toggleAnnotationVisibility = useCallback(() => {
    annotations.forEach(
      (annotation: AnnotationPotreeObject) =>
        (annotation.visible = areAllAnnotationsHidden)
    );
    setAllAnnotationsHidden(!areAllAnnotationsHidden);
  }, [annotations, areAllAnnotationsHidden, setAllAnnotationsHidden]);

  return toggleAnnotationVisibility;
};
